import * as React from 'react';
import { useHistory, useLocation } from 'react-router';
import {
  clearSearchFilterValuesList,
  onSortFilterSelect,
  triggerSubmitSearchCall
} from 'experiments/PWA_USF_FSR/usf-utils';
import { SortAndFiltersViewType } from 'types/search/sort-filter';
import { FlightsSortAndFilters } from '@shared-ui/retail-sort-and-filter-flights';
import { useSortAndFilterInput, useStores } from 'utility/hooks';

export const UniversalSortFilters = () => {
  const { context, searchCriteriaStore } = useStores();
  const history = useHistory();
  const location = useLocation();
  const sortAndFilterInput = useSortAndFilterInput();
  const onFieldChange = React.useCallback((field, event) => onSortFilterSelect(field, event, searchCriteriaStore), [
    searchCriteriaStore
  ]);

  const onSubmit = React.useCallback(() => triggerSubmitSearchCall(searchCriteriaStore, context, history, location), [
    searchCriteriaStore,
    context,
    history,
    location
  ]);

  const onRemoveAllAppliedFilters = React.useCallback(() => {
    const { dialogSortAndFilter } = searchCriteriaStore;
    dialogSortAndFilter.searchFilterValuesList = clearSearchFilterValuesList(
      searchCriteriaStore.hasSmartShoppingCriteria,
      dialogSortAndFilter.searchFilterValuesList
    );
    dialogSortAndFilter.sortOption = null;
  }, [searchCriteriaStore]);

  const onOpenDialog = React.useCallback(() => {
    const { dialogSortAndFilter, searchCriteria } = searchCriteriaStore;
    dialogSortAndFilter.sortOption = Object.assign({}, searchCriteria.sortOption);
    dialogSortAndFilter.searchFilterValuesList = JSON.parse(JSON.stringify(searchCriteria.searchFilterValuesList));
  }, [searchCriteriaStore]);

  return (
    <FlightsSortAndFilters
      onFieldChange={onFieldChange}
      onSubmit={onSubmit}
      onRemoveAllAppliedFilters={onRemoveAllAppliedFilters}
      view={SortAndFiltersViewType.SORT_AND_FILTERS}
      inputs={sortAndFilterInput}
      onOpenDialog={onOpenDialog}
      withExtraMarginBlockEnd
    />
  );
};
